<template>
    <div class="swatch-designer" id="konfigurator">
        <!-- component changes when vm.currentview changes! -->
        <component
                :is="currentView"
                :items="selectItems"
                :box="selectBox"
                :msg="msg"
                :zoom="zoom"
                :show.sync="showModal"
                :personal="personal"
                :isactive="isactive"
                :baseurl="baseurl"
                :translations="translations"
                :muster1="muster1"
                :muster2="muster2"
                :muster3="muster3"
                :muster4="muster4"
                :currentData="currentData">
        </component>


        <div class="designer-content-col">
            <div class="product-img-box">
                <div class="selection-overview">
                    <ol class="selection-overview-size">
                        <li class="bignumber-1"><img v-if="url1 !== ''" v-bind:src="url1"/>
                            <span v-if="url1 !== ''" :id="personal['muster1']" @click="remove" class="remove">X</span>
                            <span v-if="url1 !== ''" :id="personal['muster1']" @click="zoomFabric"
                                  class="collect-detail" v-bind:data-refnr="personal['muster1']"
                                  v-bind:data-title="currentData['muster1'].name"
                                  v-bind:data-infotext="currentData['muster1'].infotext"
                                  v-bind:data-price="currentData['muster1'].price"
                                  v-bind:data-weave="currentData['muster1'].weave"
                                  v-bind:data-yarn="currentData['muster1'].yarn"
                                  v-bind:data-weight="currentData['muster1'].weight"
                                  v-bind:data-composition="currentData['muster1'].composition"
                                  v-bind:data-zoom="currentData['muster1'].zoom"></span>
                        </li>
                        <li class="bignumber-2"><img v-if="url2 !== ''" v-bind:src="url2"/>
                            <span v-if="url2 !== ''" :id="personal['muster2']" @click="remove" class="remove">X</span>
                            <span v-if="url2 !== ''" :id="personal['muster2']" @click="zoomFabric"
                                  class="collect-detail" v-bind:data-refnr="personal['muster2']"
                                  v-bind:data-title="currentData['muster2'].name"
                                  v-bind:data-infotext="currentData['muster2'].infotext"
                                  v-bind:data-price="currentData['muster2'].price"
                                  v-bind:data-weave="currentData['muster2'].weave"
                                  v-bind:data-yarn="currentData['muster2'].yarn"
                                  v-bind:data-weight="currentData['muster2'].weight"
                                  v-bind:data-composition="currentData['muster2'].composition"
                                  v-bind:data-zoom="currentData['muster2'].zoom"></span>
                        </li>
                        <li class="bignumber-3"><img v-if="url3 !== ''" v-bind:src="url3"/>
                            <span v-if="url3 !== ''" :id="personal['muster3']" @click="remove" class="remove">X</span>
                            <span v-if="url3 !== ''" :id="personal['muster3']" @click="zoomFabric"
                                  class="collect-detail" v-bind:data-refnr="personal['muster3']"
                                  v-bind:data-title="currentData['muster3'].name"
                                  v-bind:data-infotext="currentData['muster3'].infotext"
                                  v-bind:data-price="currentData['muster3'].price"
                                  v-bind:data-weave="currentData['muster3'].weave"
                                  v-bind:data-yarn="currentData['muster3'].yarn"
                                  v-bind:data-weight="currentData['muster3'].weight"
                                  v-bind:data-composition="currentData['muster3'].composition"
                                  v-bind:data-zoom="currentData['muster3'].zoom"></span>
                        </li>
                        <li class="bignumber-4"><img v-if="url4 !== ''" v-bind:src="url4"/>
                            <span v-if="url4 !== ''" :id="personal['muster4']" @click="remove" class="remove">X</span>
                            <span v-if="url4 !== ''" :id="personal['muster4']" @click="zoomFabric"
                                  class="collect-detail" v-bind:data-refnr="personal['muster4']"
                                  v-bind:data-title="currentData['muster4'].name"
                                  v-bind:data-infotext="currentData['muster4'].infotext"
                                  v-bind:data-price="currentData['muster4'].price"
                                  v-bind:data-weave="currentData['muster4'].weave"
                                  v-bind:data-yarn="currentData['muster4'].yarn"
                                  v-bind:data-weight="currentData['muster4'].weight"
                                  v-bind:data-composition="currentData['muster4'].composition"
                                  v-bind:data-zoom="currentData['muster4'].zoom"></span>
                        </li>
                    </ol>
                </div>
                <div id="logme"></div>
            </div>
        </div>

        <!-- //RIGHT INFO BOX -->

        <div class="infobox">
            <div class="top-step-name basic-border basic-color">4 Stoffmuster<span
                    class="extra_price"> 3,90 &euro;</span> <span class="tax-details">{{{ priceInfo }}}</span></div>
            <div class="">
                <form :action="checkoutUrl" method="post" id="product_addtocart_form" enctype="multipart/form-data">
                    <input type="hidden" class="input-text required-entry product-custom-option" id="stoffprobe1"
                           name="options[646]" :value="personal['muster1']">
                    <input type="hidden" class="input-text" id="stoffprobe2" name="options[647]"
                           :value="personal['muster2']">
                    <input type="hidden" class="input-text" id="stoffprobe3" name="options[648]"
                           :value="personal['muster3']">
                    <input type="hidden" class="input-text" id="stoffprobe4" name="options[649]"
                           :value="personal['muster4']">
                    <button @click="addToCart" class="button btn-cart" type='button'>In den Warenkorb</button>
                </form>
            </div>
            <div class="info-text">
                <div class="inner-info-text">Sie können viele Stoffe von tailorjack als Stoffmuster bestellen. Der
                    Kaufpreis für die Stoffmuster wird Ihrem Kundenkonto bei tailorjack gutgeschrieben. Bei Ihrer
                    nächsten Bestellung für Hemden, Blusen oder Anzüge zahlen Sie also entsprechend weniger.
                </div>
            </div>
            <div v-show="flash.error || flash.success"
                 v-bind:class="[ 'fabric-sample-popup', 'basic-bg', (flash.success ? 'flash-success' : 'flash-error')]"
                 id="flash">
                <div class="text-icon">
                    <span class="icon"></span>
                    <div class="text">{{ flash.error }} {{ flash.success }}</div>
                </div>
            </div>
        </div>
        <zoom v-if="zoom" :zoom="zoom" :show.sync="show" :globals="globals" :muster1="muster1" :muster2="muster2"
              :muster3="muster3" :muster4="muster4" :isactive="isactive"></zoom>
    </div>
</template>

<script>
var jQuery = require('jquery')

import Fabric from './components/Fabric'
import Zoom from './partials/Zoom.vue'

export default {
  components: {
    Fabric,
    Zoom
  },
  data: function () {
    return {
      currentView: 'fabric',
      count: 0,
      msg: Object,
      session: Object,
      flash: Object,
      isactive: [],
      baseurl: window.stoffmuster['baseurl'],
      invurl: window.stoffmuster.invurl,
      checkoutUrl: '',
      isloggedin: window.stoffmuster.loggedin,
      measurementblock: window.stoffmuster.measurementblock,
      imgcaption: window.stoffmuster.translations.imgcaption,
      seoblock: window.stoffmuster.translations.seoBlock,
      addtocart: window.stoffmuster.translations['Add to Cart'],
      translations: window.stoffmuster.translations,
      priceInfo: window.stoffmuster.priceInfo,
      selects: [],
      personal: { muster1: '', muster2: '', muster3: '', muster4: '', configure_id: '0' },
      defaults: { muster1: '', muster2: '', muster3: '', muster4: '', configure_id: '0' },
      steps: ['Stoff'],
      fabrics: [],
      designName: 'Mein Design',
      design: [],
      designId: window.stoffmuster.designId,
      selectItems: [],
      currentData: {},
      globals: window.stoffmuster,
      selectBox: [],
      zoom: { img: '', title: '', text: '', price: '' },
      'summary': [],
      'showModal': false
    }
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      twoWay: true
    }
  },
  created: function () {
    /*global localStorage: false */
    if (localStorage.getItem('swatch_configure_id') > 0) {
      this.personal['configure_id'] = localStorage.getItem('swatch_configure_id')
      localStorage.setItem('swatch_configure_id', 0)
    }
    this.getCheckoutUrl()
    jQuery.getJSON(this.baseurl + '/designer/ajax/getFabricList', { swatch: '1' }, function (data) {
      this.fabrics = data
      this.personal = this.getPersonalData()
    }.bind(this))
  },
  computed: {
    url1: function () { return (this.personal['muster1'] ? this.baseurl + 'media/' + this.currentData.muster1.zoom : '') },
    url2: function () { return (this.personal['muster2'] ? this.baseurl + 'media/' + this.currentData.muster2.zoom : '') },
    url3: function () { return (this.personal['muster3'] ? this.baseurl + 'media/' + this.currentData.muster3.zoom : '') },
    url4: function () { return (this.personal['muster4'] ? this.baseurl + 'media/' + this.currentData.muster4.zoom : '') }
  },
  methods: {
    getPersonalData: function () {
      var result = {}
      var data = this.personal
      if (data !== undefined) {
        var keys = Object.keys(data)
        var i = 0
        var key
        while (keys[i]) {
          key = keys[i]
          result[key] = ((localStorage.getItem(key)) ? JSON.parse(localStorage[key]) : data[key])
          if (result[key] !== '') {
            this.setCurrentData(result[key], key)
            this.isactive.push(result[key])
          }
          i++
        }
      }
      return result
    },
    resetConfig: function () {
      var data = this.personal
      var keys = Object.keys(data)
      var key
      var i = 0
      while (keys[i]) {
        key = keys[i]
        this.personal[key] = this.defaults[key]
        if (localStorage.getItem(key)) {
          localStorage.removeItem(key)
        }
        i++
      }
      this.personal = this.defaults
      this.currentData = {}
    },
    addToCart: function () {
      if (!this.personal['muster1'] && !this.personal['muster2'] && !this.personal['muster3'] && !this.personal['muster4']) {
        this.setMessage({ 'error': this.translations['Please select at least 1 fabric.'] })
      } else {
        jQuery('#product_addtocart_form').submit().done(this.resetConfig())
      }
    },
    getCheckoutUrl: function () {
      if (this.personal['configure_id'] > 0) {
        this.checkoutUrl = window.stoffmuster['baseurl'] + 'checkout/cart/updateItemOptions/id/' + this.personal['configure_id'] + '/'
      } else {
        jQuery.getJSON(window.stoffmuster['baseurl'] + 'designer/ajax/getAddToCartUrl', { type: 'stoffmuster' }, function (data) {
          var getCheckoutUrl = data
          getCheckoutUrl = getCheckoutUrl.checkoutUrl
          this.checkoutUrl = getCheckoutUrl
        }.bind(this))
      }
    },
    remove: function (event) {
      var val = event.currentTarget.id
      var i
      var key
      for (i = 1; i < 5; i++) {
        key = 'muster' + i
        if (this.personal[key] === val) {
          this.personal[key] = ''
          localStorage.removeItem(key)
        }
      }
      var index = this.isactive.indexOf(val)
      if (index > -1) {
        this.isactive.splice(index, 1)
      }
    },
    setMessage: function (msg) {
      this.flash = msg
      jQuery('#flash').fadeIn('slow').delay(2000).fadeOut('slow')
    },
    zoomFabric: function (event) {
      this.zoom = {
        img: this.baseurl + 'media/' + event.currentTarget.dataset.zoom,
        title: event.currentTarget.dataset.title,
        infotext: event.currentTarget.dataset.infotext,
        weight: event.currentTarget.dataset.weight,
        composition: event.currentTarget.dataset.composition,
        weave: event.currentTarget.dataset.weave,
        yarn: event.currentTarget.dataset.yarn,
        refnr: event.currentTarget.dataset.refnr,
        price: Number(event.currentTarget.dataset.price).toFixed(2)
      }
      this.show = true
    },
    setCurrentData: function (sku, index) {
      this.currentData[index] = jQuery.grep(this.fabrics, function (e) { return e.ref_number === sku })[0]
    }
  },
  events: {
    getFabricData: function (event) {
      var selectorId = event.currentTarget.id
      window.stoffmuster.extraPrices['fabric'] = event.currentTarget.dataset.price
      if (selectorId !== '') {
        jQuery.getJSON(window.stoffmuster['baseurl'] + 'designer/ajax/getList', { target: 'fabric', qlty: selectorId, type: 'shirt' }, function (data) {
          this.fabrics = data
        }.bind(this))
      }
    },
    updatePersonalData: function (data) {
      /*global localStorage: false */
      if (data[0].length && data[1] !== undefined) {
        if (data !== undefined) {
          var keys = Object.keys(this.personal)
          var i = 0
          var key
          var remove = false
          var personal = this.personal
          Object.keys(personal).forEach(function (key) {
            if (personal[key] === data[1]) {
              personal[key] = ''
              localStorage.removeItem(key)
              remove = true
            }
          })
          if (!remove) {
            while (keys[i]) {
              key = keys[i]
              if (this.personal[key] === '') {
                this.personal[key] = data[1]
                this.setCurrentData(data[1], key)
                localStorage.setItem(key, JSON.stringify(data[1]))
                break
              } else {
                i++
                continue
              }
            }
          }
        }
      }
    },
    setSwatch: function (object) {
      this[object.key] = object.value
      this.personal[object.key] = object.value
      this.setCurrentData(object.value, object.key)
      console.log(object)
    },
    setMsg: function (msg) {
      this.setMessage(msg)
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// App.vue?0e7b77e0